/* eslint no-unused-vars: "off" */
import React, { useState } from 'react';
import SlideDown from 'react-slidedown';
import { useGatedAccess } from '@carvana/core-auth';
import {
  DocDownloadListsWrapper,
  DownloadListWrapper,
  DownloadListItem,
  DownloadItemTitle,
  DownloadSpinner,
  DocDownloadListContainer,
  DocDownloadRow,
  HeaderButton,
  HR,
  SubText,
  ChevronIconWrapper,
} from './DocDownloadList.styles';
import DownloadIcon from '../../../assets/DownloadIcon';
import { downloadDocument } from '../../../services/OvpPageService';
import ChevronIcon from '../../../assets/ChevronIcon';
import { GloveBoxEventProps, AnalyticEvents } from '../../../constants';

const DownloadList = ({ items, env, clickEventHandler }: any) => {
  const loadingArray = new Array(items.length).fill(false);
  const [isLoading, setLoading] = useState(loadingArray);
  const gate = useGatedAccess();

  const downloadHandler = (index: number, documentName: string, link: string) => {
    // OVP Card Click event
    clickEventHandler(AnalyticEvents.ovpCardClicked);
    clickEventHandler(AnalyticEvents.ovpGloveBoxDownload, GloveBoxEventProps[documentName]);

    if (isLoading[index]) {
      return;
    }

    isLoading[index] = true;
    setLoading([...isLoading]);

    downloadDocument(documentName, link, env)
      .then(async (response: any) => {
        if (response) {
          // Create a Blob from the PDF Stream
          const file = new Blob([response], { type: response.type });
          const fileURL = URL.createObjectURL(file);
          // Logic to add name to file
          const documentLink = document.createElement('a');
          documentLink.href = fileURL;

          // Name for the downloaded file
          documentLink.download = documentName;

          // Triggers the click event
          documentLink.click();
        }
        isLoading[index] = false;
        setLoading([...isLoading]);
        // setLoading((prevState: any) => prevState[documentName] = false);
      })
      .catch((error: any) => {
        isLoading[index] = false;
        setLoading([...isLoading]);
      });
  };

  const subText = 'Please note these documents may be outdated.';

  return (
    <>
      <DownloadListWrapper>
        {items.map(({ documentName, downloadUrl }: any, index: number) => (
          <DownloadListItem
            key={documentName}
            onClick={() => gate('MyCars:DigitalGlovebox', () => downloadHandler(index, documentName, downloadUrl))}
          >
            <DownloadItemTitle data-testid={`digital-glovebox-document-${documentName.replace(' ', '-')}`}>
              {documentName}
            </DownloadItemTitle>
            {!isLoading[index] && <DownloadIcon data-testid="digital-glovebox-download-icon" key={documentName} />}
            {isLoading[index] && (
              <DownloadSpinner data-testid="digital-glovebox-download-spinner-icon" key={documentName} />
            )}
          </DownloadListItem>
        ))}
      </DownloadListWrapper>
      <HR />
      <SubText data-testid="digital-glovebox-expanded-subtext">{subText}</SubText>
    </>
  );
};

const DocDownloadList = ({ heading, documentList, clickEventHandler, env, isGloveBoxV2Experiment }: any) => {
  const [isCardOpen, setIsCardOpen] = useState(false);
  const handleAccordionClick = () => {
    if (!isCardOpen) {
      clickEventHandler(AnalyticEvents.ovpCardExpand, { type: 'digital_glovebox' });
    } else {
      clickEventHandler(AnalyticEvents.ovpCardCollapse, { type: 'digital_glovebox' });
    }

    setIsCardOpen(!isCardOpen);
  };

  return (
    <DocDownloadListsWrapper>
      <DocDownloadListContainer>
        <DocDownloadRow data-testid="digital-glovebox-expand" onClick={() => handleAccordionClick()}>
          <HeaderButton data-testid="digital-glovebox-header">{heading}</HeaderButton>
          <ChevronIconWrapper isOpen={isCardOpen}>
            <div>
              <ChevronIcon />
            </div>
          </ChevronIconWrapper>
        </DocDownloadRow>
        <SlideDown>
          {isCardOpen && (
            <DownloadList
              items={documentList}
              env={env}
              clickEventHandler={clickEventHandler}
              isGloveBoxV2Experiment={isGloveBoxV2Experiment}
            />
          )}
        </SlideDown>
      </DocDownloadListContainer>
    </DocDownloadListsWrapper>
  );
};

export default DocDownloadList;
